import React, { useState } from "react";
import {
    Modal,
    Box,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    IconButton,
    Typography,
    Button,
    RadioGroup,
    FormControlLabel,
    Radio,
    Autocomplete,
    InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { Expiry_period } from "../../../Utility/Constants";
import CommonValidation from "../../../Components/CommonFunctions/CommonValidation";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const StoreStockViewPop = ({ open, onClose, forOnlyView, selectedData, forEdit, successMessage, errorMessage }) => {
    // Form state
    const [formState, setFormState] = useState({
        product_code: selectedData?.product_code || "",
        product_name: selectedData?.product_name || "",
        common_name: selectedData?.common_name || "",
        short_name: selectedData?.short_name || "",
        manufacturer_name: selectedData?.manufacturer_name || "",
        model_no: selectedData?.model_no || "",
        rol: selectedData?.rol_quantity || "",
        roq: selectedData?.roq_quantity || "",
        gst_percentage: selectedData?.gst_percentage || "",
        hsn_code: selectedData?.hsn_code || "",
        stock_in_quantity: selectedData?.stock_in_quantity || "",
        mrp_per_quantity: selectedData?.mrp_per_quantity || "",
        physical_box_no: selectedData?.physical_box_no || "",
        id: selectedData?.id || null,
        product_id: selectedData?.product_id || null,
        expiry_alert_period: Expiry_period.find((list) => list?.value == selectedData?.expiry_alert_period) || null,
        reason: selectedData?.reason || 1,
        comments: selectedData?.comments || "",
        expiry_date: selectedData?.expiry_date ? selectedData?.expiry_date : "",
    });

    // Handle input change
    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === "stock_in_quantity") {
            if (value === "" || (CommonValidation.numberOnly(value) && value?.length <= 4)) {
                setFormState((prev) => ({ ...prev, [name]: +value }));
            }
        } else {
            setFormState((prev) => ({ ...prev, [name]: value }));
        }
    };

    // Reusable function to render text fields
    const renderTextField = (label, name, disable) => (
        <TextField
            label={label}
            name={name}
            fullWidth
            value={formState[name]}
            inputProps={{ maxLength: name === "comments" ? 250 : 5 }}
            disabled={forOnlyView || disable}
            onChange={handleChange}
            variant="outlined"
            size="small"
            sx={{ width: name === "comments" ? "64dvw" : "15dvw" }}
            InputProps={{
                startAdornment: (
                    (name !== "stock_in_quantity" || forOnlyView) ? null :
                        <InputAdornment position="start">
                            <IconButton disabled={formState?.stock_in_quantity == 0} emed_tid="esc_stock_qty_add" onClick={() => {
                                setFormState((prev) => ({ ...prev, [name]: prev?.stock_in_quantity - 1 }));
                            }}><RemoveIcon color='primary' /></IconButton>
                        </InputAdornment>
                ),
                endAdornment: (
                    (name !== "stock_in_quantity" || forOnlyView) ? null :
                        <InputAdornment position="end">
                            <IconButton emed_tid="esc_stock_qty_minus" onClick={() => {
                                setFormState((prev) => {
                                    const currentValue = Number(prev?.[name]) || 0
                                    const incrementedValue = currentValue + 1

                                    return {
                                        ...prev,
                                        [name]: incrementedValue > 9999 ? 9999 : incrementedValue
                                    }
                                })
                            }}><AddIcon color='primary' /></IconButton>
                        </InputAdornment>
                ),
            }}
        />
    );

    console.log(formState);

    const updateStock = () => {
        try {
            // no needed sivaraj confirm
            // else if (formState?.stock_in_quantity == "") {
            //     errorMessage('Please Enter Current Stock')
            // } 
            if (!formState?.product_name) {
                errorMessage('Please Enter Product Name')
            } else if (!formState?.comments && forEdit) {
                errorMessage('Please Enter Comments')
            } else {
                let data = {
                    'stock_id': formState?.id,
                    'reason': formState?.reason || "",
                    'comments': formState?.comments || "",
                    'product_id': formState?.product_id,
                    'rol_quantity': +formState?.rol || 0,
                    'roq_quantity': +formState?.roq || 0,
                    'product_name': formState?.product_name,
                    'stock_in_quantity': +formState?.stock_in_quantity || 0,
                    'physical_box_no': formState?.physical_box_no,
                    'expiry_alert_period': +formState?.expiry_alert_period?.value || 0,
                    'expiry_date': formState?.expiry_date ? new Date(formState?.expiry_date).toISOString().split("T")[0] : null,
                }
                RestAPIService.updateWithOutId(data, Serviceurls.STORE_PRODUCT_STOCK_CORRECTION)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            successMessage(response.data.message)
                            onClose(true)
                        }
                    }).catch(e => {
                        if (e?.response?.data?.status === 'fail') {
                            errorMessage(e.response.data.message)
                        } else {
                            errorMessage(e.message)
                        }
                    })
            }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const onChangeHandlerAuto = (event, newvalue, name) => {
        switch (name) {
            default: setFormState((prevData) => ({
                ...prevData,
                [name]: newvalue,
            }))
                break;
        };
    };

    const autoComplete = (label, name, val, list, option_key, disable = false) => {
        return (
            <Box>
                <Autocomplete
                    size={'small'}
                    options={list}
                    name={name}
                    disabled={forOnlyView || disable}
                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option[option_key]}
                    value={val}
                    onChange={(event, newValue) => { onChangeHandlerAuto(event, newValue, name) }}
                    renderInput={(params) => <TextField {...params} label={label} sx={{ width: "15dvw" }} disabled={forOnlyView || disable} />}
                />
            </Box>
        )
    }

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "70dvw", // Adjust width dynamically
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 3,
                    borderRadius: "8px",
                }}
            >
                {/* Header with Close Button */}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    <Typography variant="h6">Stock Details</Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* Form Fields */}
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
                    {renderTextField("Product Code", "product_code", true)}
                    {renderTextField("Product Name", "product_name", true)}
                    {renderTextField("Common Name", "common_name", true)}
                    {renderTextField("Short Name", "short_name", true)}
                    {renderTextField("Manufacture Name", "manufacturer_name", true)}
                    {renderTextField("Model/Serial No", "model_no", true)}
                    {renderTextField("ROL", "rol", false)}
                    {renderTextField("ROQ", "roq", false)}
                    {renderTextField("GST", "gst_percentage", true)}
                    {renderTextField("Hsn Code", "hsn_code", true)}
                    {renderTextField("Physical Box No", "physical_box_no", false)}
                    {autoComplete("Expiry Alert", "expiry_alert_period", formState.expiry_alert_period, Expiry_period, "label", true)}
                    {renderTextField("Stock Quantity", "stock_in_quantity", false)}
                    {renderTextField("MRP/Qty", "mrp_per_quantity", true)}
                    <Box>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={formState?.expiry_date ? formState?.expiry_date : null}
                                name={"datePicker"}
                                inputFormat={'MM-YYYY'}
                                views={['year', 'month']}
                                disabled
                                onChange={(newDate) => {
                                    setFormState((prevData) => ({
                                        ...prevData,
                                        "expiry_date": newDate,
                                    }));
                                }}
                                renderInput={(params) => <TextField
                                    {...params}
                                    disabled
                                    label={"Expiry Date"}
                                    name={"expiry_date"}
                                    variant="outlined"
                                    onKeyDown={(e) => e.preventDefault()}
                                    sx={{ width: '15dvw' }}
                                    size='small'
                                />}
                            />
                        </LocalizationProvider>
                    </Box>
                    {forEdit ? <>
                        <FormControl sx={{ marginLeft: "1.5vw", display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <RadioGroup
                                value={formState?.reason}
                                sx={{ display: 'flex', flexDirection: 'row', marginLeft: '1vw' }}
                                onChange={(e) => {
                                    setFormState((prev) => ({ ...prev, "reason": e.target.value }));
                                }}
                                emed_tid='active_inactive_filter'
                            >
                                <FormControlLabel value={1} control={<Radio emed_tid="esc_Breakage" />} label={'Breakage'} />
                                <FormControlLabel value={2} control={<Radio emed_tid="esc_Loss" />} label={'Loss'} />
                                <FormControlLabel value={3} control={<Radio emed_tid="esc_Expired" />} label={'Expired'} />
                                <FormControlLabel value={4} control={<Radio emed_tid="esc_Miscellaneous" />} label={'Miscellaneous'} />
                                <FormControlLabel value={5} control={<Radio emed_tid="esc_Others" />} label={'Others'} />
                            </RadioGroup>
                        </FormControl>
                        {renderTextField("Comments *", "comments", false)}
                    </> : null}
                </Box>
                {forEdit ? <Box sx={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "flex-end" }}>
                    <Button sx={{ textTransform: "capitalize", margin: '1vw' }} variant="contained" size="small" onClick={() => { updateStock() }}>Update Stock</Button>
                </Box> : null}
            </Box>
        </Modal>
    );
};

export default StoreStockViewPop;
